import React from 'react'
import './BusinessMan.css'
import Navbar from '../Navbar/Navbar'
import BussMan1 from './BussMan1/BussMan1'

const BusinessMan = () => {
  return (
    <div className='businessman-container'>
      <Navbar/>
      <BussMan1/>
    </div>
  )
}

export default BusinessMan ;
